import {
  GET_COURSE_AND_GRADES_SELECT_LIST,
  GET_COURSE_AND_GRADES_SELECT_LIST_ERROR,
  GET_COURSE_AND_GRADES_SELECT_LIST_SUCCESS,
  GET_COURSE_SELECT_LIST,
  GET_COURSE_SELECT_LIST_ERROR,
  GET_COURSE_SELECT_LIST_LOCAL,
  GET_COURSE_SELECT_LIST_LOCAL_ERROR,
  GET_COURSE_SELECT_LIST_LOCAL_SUCCESS,
  GET_COURSE_SELECT_LIST_SUCCESS,
  GetCourseAndGradesSelectListAction,
  GetCourseAndGradesSelectListErrorAction,
  GetCourseAndGradesSelectListSuccessAction,
  GetCourseSelectListAction,
  GetCourseSelectListErrorAction,
  GetCourseSelectListLocalAction,
  GetCourseSelectListLocalErrorAction,
  GetCourseSelectListLocalSuccessAction,
  GetCourseSelectListSuccessAction,
  RESET_COURSE_SELECT_LIST_LOCAL,
  ResetCourseSelectListLocalAction,
} from "./actionTypes";
import { SelectListDto } from "../../models";

//#region Get Course Select List

export const getCourseSelectList = (): GetCourseSelectListAction => {
  return {
    type: GET_COURSE_SELECT_LIST,
    payload: null,
  };
};

export const getCourseSelectListSuccess = (
  response: SelectListDto[]
): GetCourseSelectListSuccessAction => {
  return {
    type: GET_COURSE_SELECT_LIST_SUCCESS,
    payload: response,
  };
};

export const getCourseSelectListError = (
  error: any
): GetCourseSelectListErrorAction => {
  return {
    type: GET_COURSE_SELECT_LIST_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Course and Grades Select List

export const getCourseAndGradesSelectList =
  (): GetCourseAndGradesSelectListAction => {
    return {
      type: GET_COURSE_AND_GRADES_SELECT_LIST,
      payload: null,
    };
  };

export const getCourseAndGradesSelectListSuccess = (
  response: SelectListDto[]
): GetCourseAndGradesSelectListSuccessAction => {
  return {
    type: GET_COURSE_AND_GRADES_SELECT_LIST_SUCCESS,
    payload: response,
  };
};

export const getCourseAndGradesSelectListError = (
  error: any
): GetCourseAndGradesSelectListErrorAction => {
  return {
    type: GET_COURSE_AND_GRADES_SELECT_LIST_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Course Select List Local/ internal

export const getCourseSelectListLocal = (): GetCourseSelectListLocalAction => {
  return {
    type: GET_COURSE_SELECT_LIST_LOCAL,
    payload: null,
  };
};

export const getCourseSelectListLocalSuccess = (
  response: SelectListDto[]
): GetCourseSelectListLocalSuccessAction => {
  return {
    type: GET_COURSE_SELECT_LIST_LOCAL_SUCCESS,
    payload: response,
  };
};

export const getCourseSelectListLocalError = (
  error: any
): GetCourseSelectListLocalErrorAction => {
  return {
    type: GET_COURSE_SELECT_LIST_LOCAL_ERROR,
    payload: error,
  };
};

export const resetCourseSelectListLocal =
  (): ResetCourseSelectListLocalAction => {
    return {
      type: RESET_COURSE_SELECT_LIST_LOCAL,
      payload: null,
    };
  };

//#endregion
